import React, { useEffect, useLayoutEffect } from "react";
import {Helmet} from 'react-helmet';
import { useLocation } from "react-router-dom";
import {useUser} from "../Data/UserContext";
import { seedAnalyticsIdentityBeforeGtm, syncAnalyticsIdentityToDataLayer } from "../utils/gtm";
import { getJwt, getSessionToken, getUserId, setUserId } from "../utils/authHeaders";
import { isAnalyticsPathExcluded, isDevEnv } from "../utils/analyticsEnv";

const gtmId = process.env.GTM_ID;
const analyticsEnabled = !isDevEnv();

export const CookieScripts = () => {
    const {user} = useUser();
    const location = useLocation();
    const pathExcluded = isAnalyticsPathExcluded(location.pathname);

    // Seed sticky user_status before GTM script (Helmet) injects / fires gtm.js.
    useLayoutEffect(() => {
        if (!analyticsEnabled || !gtmId || pathExcluded) return;
        seedAnalyticsIdentityBeforeGtm(user?.userId ?? null);
        // Mount / path change seed when leaving excluded routes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathExcluded]);

    useEffect(() => {
        if (!analyticsEnabled || !gtmId || pathExcluded) return;
        if (user?.userId) {
            syncAnalyticsIdentityToDataLayer(String(user.userId));
            if (!getUserId()) {
                setUserId(user.userId);
            }
            return;
        }
        const stillHasAuth =
            Boolean(getJwt()) ||
            Boolean(getSessionToken()) ||
            Boolean(getUserId());
        if (!stillHasAuth) {
            syncAnalyticsIdentityToDataLayer(null);
        }
    }, [user, pathExcluded]);

    // Don't render anything if no tracking IDs are configured, analytics disabled, or path excluded
    if (!analyticsEnabled || !gtmId || pathExcluded) {
        return null;
    }

    return (
    <Helmet>
      {/* <!-- Google Tag Manager --> */}
      <script>
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${String(gtmId)}');
        `}
      </script>
      <noscript>
        {`<iframe
          title='googletagmanager'
          src='https://www.googletagmanager.com/ns.html?id=${String(gtmId)}'
          height='0'
          width='0'
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>`}
      </noscript>
      {/* <!-- End Google Tag Manager --> */}
    </Helmet>
  );
};
